import { render, staticRenderFns } from "./metafield.list.item.vue?vue&type=template&id=1fd0f93b&"
import script from "./metafield.list.item.vue?vue&type=script&lang=ts&"
export * from "./metafield.list.item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports